import axios from "axios";
import { CheckLoginServer } from "../Helpers/CheckLogin";
import {
    DeleteLocalStorage,
    GetLocalStorage,
    SetLocalStorage,
} from "../Helpers/LocalStorage/LocalStorage";
import { BaseUrl } from "./Base";
import { AgainOpenLoginSignUp, DoneLoginSignUp } from "./ToggleSignupA";

const axiosInstance = axios.create({
    baseURL: BaseUrl,
    withCredentials: true,
});

let CheckErrorVar;
function CheckError(error) {
    CheckErrorVar = error ? true : false
}
function navigateWithPromise(id, Navigate, Dispatch) {
    return new Promise((resolve) => {
        Dispatch(DoneLoginSignUp(false));
        resolve();
    })
        .then(() => {
            const cameFromCourse = localStorage.getItem('cameFromCourse') === 'true';

                if (cameFromCourse) {
                Navigate(`/Enrollment/Course`, {
                    state: { InstituteCourseId: id },
                });
                setTimeout(() => {
                    DeleteLocalStorage("navigateToEnroll");
                }, 3000);
            } else {
                console.log("Navigation skipped: URL does not contain '/course'");
            }

            // Navigate(`/Enrollment/Course`, {
            //     state: { InstituteCourseId: id },
            // });
            // setTimeout(() => {
            //     DeleteLocalStorage("navigateToEnroll");
            // }, 3000);
            // })

        })

        .catch((error) => {
            console.error("Error:", error);
        });
}

export const LoginUser =
    (UserData, Dispatch, PageName, setCaptcha, Navigate, loginType) =>
    async (dispatch) => {
        try {
            console.log("loginType in the LoginUser is:",loginType)

            dispatch({
                type: "LoginRequest",
            });

            const { data } = await axiosInstance.post(`/api/login/${loginType}`, UserData);
            console.log("studentusereinfo", data);
            if (data?.User?.StudentInfos?.Schedule)
                data.User.StudentInfos.Schedule = JSON.parse(
                    data.User.StudentInfos.Schedule
                );

            if (data?.User?.StudentInfos?.FreeHours)
                data.User.StudentInfos.FreeHours = JSON.parse(
                    data.User.StudentInfos.FreeHours
                );

            dispatch({
                type: "LoginSuccess",
                payload: data.User,
                Auth: true,
            });
            dispatch({
                type: "GetNotificationsSuccess",
                payload: data.Notifications,
            });
            SetLocalStorage("UserInfo", {
                ...data.User,
                Notifications: data.Notifications,
            });
            setCaptcha(null);
            dispatch({
                type: "LoginError",
                payload: {},
            });
            if (GetLocalStorage("navigateToEnroll")) {
               await navigateWithPromise(
                    GetLocalStorage("navigateToEnroll"),
                    Navigate,
                    Dispatch
                );
            } else {
               await Dispatch(DoneLoginSignUp(false));
            }
        } catch (error) {
            Dispatch(AgainOpenLoginSignUp(PageName));
            dispatch({
                type: "LoginError",
                payload: error?.response?.data ? error?.response?.data : {},
            });
            setCaptcha(null);
        }
    };
export const GoogleReCapthcaLoading = (PageName) => (dispatch) => {
    try {
        if (PageName === "Sign Up") dispatch({ type: "SignUpRequest" });
        else if (PageName === "Sign In") dispatch({ type: "LoginRequest" });
    } catch (error) {}
};
export const SignUpWithGoogleAction =
    (SignUpInfo, Dispatch, PageName) => async (dispatch) => {
        try {
            dispatch({
                type: "SignUpRequest",
            });
            const { data } = await axiosInstance.post(
                `/api/signup/Google`,
                SignUpInfo
            );

            dispatch({
                type: "SignUpSuccess",
                payload: data?.User,
            });
            dispatch({
                type: "GetNotificationsSuccess",
                payload: data.Notifications,
            });

            SetLocalStorage("UserInfo", {
                ...data.User,
                Notifications: data.Notifications,
            });
            Dispatch(DoneLoginSignUp(false));
            dispatch({
                type: "SignUpFailure",
                payload: {},
            });
        } catch (error) {
            Dispatch(AgainOpenLoginSignUp(PageName));
            dispatch({
                type: "SignUpFailure",
                payload: error?.response?.data ? error?.response?.data : {},
            });
        }
    };
export const LoginWithGoogleAction =
    (LoginInfo, Dispatch, PageName) => async (dispatch) => {
        try {
            dispatch({
                type: "LoginRequest",
            });
            const res = await axiosInstance.post(
                `/api/login/Google`,
                LoginInfo
            );

            const { data } = res;

            dispatch({
                type: "LoginSuccess",
                payload: data.User,
                Auth: true,
            });
            dispatch({
                type: "GetNotificationsSuccess",
                payload: data.Notifications,
            });
            SetLocalStorage("UserInfo", {
                ...data.User,
                Notifications: data.Notifications,
            });
            Dispatch(DoneLoginSignUp(false));
        } catch (error) {
            Dispatch(AgainOpenLoginSignUp(PageName));
            dispatch({
                type: "LoginFailure",
                payload: error,
            });
        }
    };

export const SignUpUser =
    (UserData, Dispatch, PageName, setCaptcha, setOtpPopup, setResync, VerifyPopup) =>
    async (dispatch) => {
  

        try {
            dispatch({
                type: "SignUpRequest",
            });
            const { data } = await axiosInstance.post(`/api/signup`, UserData);

            console.log("data=> ", data)
            dispatch({
                type: "SignUpSuccess",
                payload: data,
                Auth: true,
            });
            
            dispatch({
                type: "GetNotificationsSuccess",
                payload: data.Notifications,
            });

            // SetLocalStorage("Usertoken", {
            //    email: data?.User?.Email,
            //    token : data?.User?.ResetPasswordToken,
            //    expire: data?.User?.ResetPasswordExpire
            // });
            // setCaptcha(null);
           /*  setOtpPopup(true) */

           SetLocalStorage("UserInfo", {
            ...data.User,
            // Notifications: data.Notifications,
        });

            dispatch(DoneLoginSignUp(false));

            return data


            // Dispatch(DoneLoginSignUp(false));
            // setResync((prev) => !prev);

    
        } catch (error) {

            Dispatch(AgainOpenLoginSignUp(PageName));
            dispatch({
                type: "SignUpError",
                payload: error?.response?.data ? error?.response?.data : {},
              
            });
            setCaptcha(null);
            CheckError(error)
        }
        // if(!CheckErrorVar) VerifyPopup() 
        // if(!CheckErrorVar) handleDatasavedCB() 
    };

    export const verifyOtp =(payload)=> async(dispatch)=> {
        try {
          dispatch({
            type: "verifyOtpRequest"
          });
          const {data} = await axiosInstance.post("/api/verify-registeredEmail", payload);

          dispatch({
            type: "verifyOtpSuccess",
            payload: data,
            Auth: true
          })

          dispatch({
            type: "GetNotificationsSuccess",
            payload: data.Notifications,
        });

        SetLocalStorage("UserInfo", {
                ...data.User,
                Notifications: data.Notifications,
            });

        dispatch(DoneLoginSignUp(false));

        return data

        }catch(error){
            throw error
        }
    }

    export const verifiedStudentOtp =(payload)=> async(dispatch)=> {
        try {
          dispatch({
            type: "verifyOtpRequest"
          });
          alert("verifiedStudentOtp")
          const {data} = await axiosInstance.post("/api/verify-registeredStudentEmail", payload);

          dispatch({
            type: "verifyOtpSuccess",
            payload: data,
            Auth: true
          })

          dispatch({
            type: "GetNotificationsSuccess",
            payload: data.Notifications,
        });

        SetLocalStorage("UserInfo", {
                ...data.User,
                Notifications: data.Notifications,
            });

        dispatch(DoneLoginSignUp(false));

        return data

        }catch(error){
            throw error
        }
    }

export const RegisterInstituteA = (UserData, cb) => async (dispatch) => {
    try {
        dispatch({
            type: "RegisterInstituteRequest",
        });

        const { data } = await axiosInstance.post(
            `/api/Institute/Register`,
            UserData
        );
        dispatch({
            type: "RegisterInstituteSuccess",
            payload: data,
            Auth: true,
        });
        dispatch({
            type: "GetNotificationsSuccess",
            payload: data.Notifications,
        });
        SetLocalStorage("UserInfo", {
            ...data.User,
            Notifications: data.Notifications,
        });

        cb();
    } catch (error) {
        dispatch({
            type: "RegisterInstituteError",
            payload: error?.response?.data ? error?.response?.data : {},
        });
    }
};

// export const RegisterNewInstituteA = (UserData, cb) => async (dispatch) => {
//     try {
//         dispatch({
//             type: "RegisterInstituteRequest",
//         });

//         const { data } = await axiosInstance.post(
//             `/api/NewInstitute/Register`,
//             UserData
//         );
//         dispatch({
//             type: "RegisterInstituteSuccess",
//             payload: data,
//             Auth: true,
//         });
//         dispatch({
//             type: "GetNotificationsSuccess",
//             payload: data.Notifications,
//         });
//         SetLocalStorage("UserInfo", {
//             ...data.User,
//             Notifications: data.Notifications,
//         });

//         cb();
//     } catch (error) {
//         dispatch({
//             type: "RegisterInstituteError",
//             payload: error?.response?.data ? error?.response?.data : {},
//         });
//     }
// };


export const RegisterNewInstituteA = (UserData, cb, onError) => async (dispatch) => {
    try {
        dispatch({
            type: "RegisterInstituteRequest",
        });

        const { data } = await axiosInstance.post(
            `/api/NewInstitute/Register`,
            UserData,
            {
                headers: {
                    "Content-Type": "multipart/form-data" // Ensure correct headers
                }
            }
        );

        dispatch({
            type: "RegisterInstituteSuccess",
            payload: data,
            Auth: true,
        });

        cb();
    } catch (error) {
        const errorMsg = error?.response?.data?.message || "Something went wrong";

        dispatch({
            type: "RegisterInstituteError",
            payload: error?.response?.data ? error?.response?.data : {},
        });

        if (onError) onError(errorMsg); // ⬅️ Send error to UI
    }
};

export const RegisterNewInstituteOwnersdataA = (UserData, instituteId,  onSuccess, onError) => async (dispatch) => {
    try {
        dispatch({
            type: "RegisterInstituteRequest",
        });

        const { data } = await axiosInstance.post(
            `/api/NewInstitute/RegisterOwnersData/${instituteId}`,
            UserData,
            {
                headers: {
                    "Content-Type": "multipart/form-data" // Ensure correct headers
                }
            }
        );

        dispatch({
            type: "RegisterInstituteSuccess",
            payload: data,
            Auth: true,
        });

        // cb();
        if (onSuccess) onSuccess(); // ✅ resolve
    } catch (error) {
        dispatch({
            type: "RegisterInstituteError",
            payload: error?.response?.data ? error?.response?.data : {},
        });

        if (onError) onError(error?.response?.data?.message || "Submission failed"); // ✅ reject
    }
};

export const RegisterPaypalNewInstituteOwnersdataA = (UserData, instituteId, cb) => async (dispatch) => {
    try {
        dispatch({
            type: "RegisterInstituteRequest",
        });

        const { data } = await axiosInstance.post(
            `/api/NewInstitute/RegisterOwnersData/${instituteId}`,
            UserData,
            {
                headers: {
                    "Content-Type": "multipart/form-data" // Ensure correct headers
                }
            }
        );

        dispatch({
            type: "RegisterInstituteSuccess",
            payload: data,
            Auth: true,
        });

        cb();
    } catch (error) {
        dispatch({
            type: "RegisterInstituteError",
            payload: error?.response?.data ? error?.response?.data : {},
        });

    }
};

export const GetVLIAgentsAction = () => async (dispatch) => {
    try {
        dispatch({
            type: "GetVLIAgentsARequest",
        });

        const { data } = await axiosInstance.post(
            `/api/GetVLIAgentsA`,
        );

        dispatch({
            type: "GetVLIAgentsASuccess",
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: "GetVLIAgentsAError",
            payload: error,
        });
    }
};


export const SetUser = (UserInfo) => (dispatch) => {
    try {
        dispatch({
            type: "LoginRequest",
        });

        if (UserInfo)
            dispatch({
                type: "LoginSuccess",
                payload: UserInfo,
                Auth: true,
            });
        else
            dispatch({
                type: "LoginSuccess",
                payload: undefined,
                Auth: false,
            });
    } catch (error) {
        CheckLoginServer(error, dispatch);
        dispatch({
            type: "LoginError",
            payload: error,
        });
    }
};

export const LogOut = () => async (dispatch) => {
    try {
        dispatch({
            type: "LoginRequest",
        });

        const { data } = await axiosInstance.get(`/api/logout`);
        console.log("data in logout", data);
        DeleteLocalStorage("UserInfo");

        dispatch({
            type: "LoginSuccess",
            payload: undefined,
            Auth: false,
        });
    } catch (error) {
        CheckLoginServer(error, dispatch);
        dispatch({
            type: "LoginError",
            payload: error,
        });
    }
};

export const GetWishList = () => async (dispatch) => {
    try {
        dispatch({
            type: "GetWishListRequest",
        });

        const { data } = await axiosInstance.get(`/api/wishlist`);

        dispatch({
            type: "GetWishListSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error, dispatch);
        dispatch({
            type: "GetWishListError",
            payload: error,
        });
    }
};

export const RemoveFromWishList = (WishId) => async (dispatch) => {
    try {
        dispatch({
            type: "RemoveWishRequest",
        });

        const { data } = await axiosInstance.delete(`/api/wishlist`, {
            data: { WishId },
        });

        dispatch({
            type: "RemoveWishSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error, dispatch);
        dispatch({
            type: "RemoveWishError",
            payload: error,
        });
    }
};

export const AddtoWishList = (InstitutetCourseId) => async (dispatch) => {
    try {
        dispatch({
            type: "AddToWishListRequest",
        });

        const { data } = await axiosInstance.post(`/api/wishlist`, {
            InstitutetCourseId,
        });

        dispatch({
            type: "AddToWishListSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error, dispatch);
        dispatch({
            type: "AddToWishListError",
            payload: error,
        });
    }
};

export const GetPickedStudentFieldFromUsers = (UserId) => async (dispatch) => {
    try {
        dispatch({
            type: "GetPickedStudentFromUsersRequest",
        });

        const { data } = await axiosInstance.post('/api/getpickedstudentfield', {
            UserId,
        });

        dispatch({
            type: "GetPickedStudentFromUsersSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error, dispatch);
        dispatch({
            type: "GetPickedStudentFromUsersError",
            payload: error,
        });
    }
};

export const GetStartRecordingFieldFromUsers = (UserId) => async (dispatch) => {
    try {
        dispatch({
            type: "GetStartRecordingFromUsersRequest",
        });

        const { data } = await axiosInstance.post('/api/getstartrecordingfield', {
            UserId,
        });

        dispatch({
            type: "GetStartRecordingFromUsersSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error, dispatch);
        dispatch({
            type: "GetStartRecordingFromUsersError",
            payload: error,
        });
    }
};

export const GetInstituteDataAndSendOtp = (instituteId, cb) => async (dispatch) => {
    try {
        dispatch({
            type: "GetInstituteDataAndSendOtpRequest",
        });

        const { data } = await axiosInstance.post(
            `/api/GetInstituteDataAndSendOtp/${instituteId}`,
        );

        dispatch({
            type: "GetInstituteDataAndSendOtpSuccess",
            payload: data,
        });

        cb();

    } catch (error) {
        dispatch({
            type: "GetInstituteDataAndSendOtpError",
            payload: error?.response?.data ? error?.response?.data : {},
        });
    }
};


///*********************** Checkout Payment success ***************/
export const CheckoutPaymentSuccessA = (UserData, instituteId, cb) => async (dispatch) => {
    try {
        dispatch({
            type: "CheckoutPaymentSuccessRequest",
        });

        const { data } = await axiosInstance.post(
            `/api/NewInstitute/CheckoutPaymentSuccess/${instituteId}`,
            UserData,
        );

        dispatch({
            type: "CheckoutPaymentSuccess",
            payload: data,
        });

        cb();
    } catch (error) {
        dispatch({
            type: "CheckoutPaymentSuccessError",
            payload: error?.response?.data ? error?.response?.data : {},
        });
    }
};

///*********************** Checkout Payment Failure ***************/
export const CheckoutPaymentFailureA = (ErrorMessage, instituteId) => async (dispatch) => {
    try {
        dispatch({
            type: "CheckoutPaymentFailureRequest",
        });

        const { data } = await axiosInstance.post(
            `/api/NewInstitute/CheckoutPaymentFailure/${instituteId}`,
            ErrorMessage,
        );

        dispatch({
            type: "CheckoutPaymentFailureSuccess",
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: "CheckoutPaymentFailureError",
            payload: error?.response?.data ? error?.response?.data : {},
        });
    }
};

///*********************** Saving Form Data in the Json file ***************/
export const SavingInstituteFormInJsonA = (UserData, instituteId) => async (dispatch) => {
    try {
        dispatch({
            type: "SavingInstituteFormInJsonRequest",
        });

        const { data } = await axiosInstance.post(
            `/api/NewInstitute/SavingInstituteFormInJson/${instituteId}`,
            UserData,
            {
                headers: {
                    "Content-Type": "multipart/form-data" // Ensure correct headers
                }
            }
        );

        dispatch({
            type: "SavingInstituteFormInJsonSuccess",
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: "SavingInstituteFormInJsonError",
            payload: error?.response?.data ? error?.response?.data : {},
        });
    }
};


export const UpdateHeardAboutUsDataA = (UserData, instituteId, cb) => async (dispatch) => {
    try {
        dispatch({
            type: "UpdateHeardAboutUsDataRequest",
        });

        const { data } = await axiosInstance.post(
            `/api/HeardAboutUsData/${instituteId}`,
            UserData,
        );

        dispatch({
            type: "UpdateHeardAboutUsDataSuccess",
            payload: data,
            Auth: true,
        });

        cb();
    } catch (error) {
        const errorMsg = error?.response?.data?.message || "Something went wrong";

        dispatch({
            type: "UpdateHeardAboutUsDataError",
            payload: error?.response?.data ? error?.response?.data : {},
        });

    }
};